// Hook do tworzenia klienta w Panelu Handlowca – POST /sales-crm/clients

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostTraderClientRequest {
  name: string;
  id_external: number | null;
  client_group_id: number;
  is_active: boolean;
  tax_number: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  website?: string;
}

type IResponse = ICommandResponseSuccess;

const postTraderClient = (data: IPostTraderClientRequest): Promise<IResponse> =>
  axios.post('/sales-crm/clients', data);

export const usePostTraderClient = (
  options?: UseMutationOptions<IResponse, IError, IPostTraderClientRequest>
) => useMutation((data: IPostTraderClientRequest) => postTraderClient(data), options);
